'use strict'

import HorizontalLegend from './HorizontalLegend'
import LegendItem from './LegendItem'
import './HorizontalLegend.less'

export {
  HorizontalLegend, LegendItem
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/HorizontalLegend/index.js